import { render, staticRenderFns } from "./ChatMessagesHeader.vue?vue&type=template&id=862d698a&"
import script from "./ChatMessagesHeader.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports